import { Popover } from 'antd';
import React from 'react';

function CommandItem({ item }) {
  const [hovered, setHovered] = React.useState(false);

  // Extract the icon img src and label text from the AntD Button element
  const iconEl = item.props.icon;
  const label = item.props.children || item.props.title || "";
  const onClick = item.props.onClick;
  const disabled = item.props.disabled;

  // Accent colour by id
  const accentMap = {
    capture_screen:     { bg: "linear-gradient(135deg,#eff6ff,#dbeafe)", color: "#3b82f6", hover: "#eff6ff" },
    toggle_play:        { bg: "linear-gradient(135deg,#f0fdf4,#dcfce7)", color: "#16a34a", hover: "#f0fdf4" },
    reload_player:      { bg: "linear-gradient(135deg,#faf5ff,#ede9fe)", color: "#7c3aed", hover: "#faf5ff" },
    reboot_hardware:    { bg: "linear-gradient(135deg,#fffbeb,#fef3c7)", color: "#d97706", hover: "#fffbeb" },
    shutdown_hardware:  { bg: "linear-gradient(135deg,#fff1f2,#ffe4e6)", color: "#ef4444", hover: "#fff1f2" },
  };
  const id = item.props.id || "";
  const accent = accentMap[id] || { bg: "linear-gradient(135deg,#f8fafc,#f1f5f9)", color: "#64748b", hover: "#f8fafc" };

  return (
    <button
      onClick={disabled ? undefined : onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      disabled={disabled}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        width: "100%",
        padding: "8px 10px",
        borderRadius: 10,
        border: "none",
        background: hovered && !disabled ? accent.hover : "transparent",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.45 : 1,
        textAlign: "left",
        transition: "background 0.15s ease",
      }}
    >
      {/* Icon tile */}
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 34,
          height: 34,
          borderRadius: 10,
          background: accent.bg,
          flexShrink: 0,
          transition: "transform 0.15s ease",
          transform: hovered && !disabled ? "scale(1.08)" : "scale(1)",
        }}
      >
        {iconEl && React.cloneElement(iconEl, {
          style: {
            width: 16,
            height: "auto",
            pointerEvents: "none",
            marginRight: 0,
            filter: `drop-shadow(0 1px 1px rgba(0,0,0,0.12))`,
          },
        })}
      </span>
      {/* Label */}
      <span
        style={{
          fontSize: 13,
          fontWeight: 600,
          color: hovered && !disabled ? accent.color : "#0f172a",
          transition: "color 0.15s",
          lineHeight: 1.3,
        }}
      >
        {label}
      </span>
    </button>
  );
}

class ButtonGroup extends React.Component {

  renderPanel = () => {
    const { items = [], title } = this.props;

    return (
      <div
        style={{
          padding: 6,
          borderRadius: 16,
          minWidth: 210,
          background: "#ffffff",
          boxShadow: "0 12px 40px rgba(15,23,42,0.12), 0 2px 8px rgba(15,23,42,0.06)",
          border: "1px solid #f1f5f9",
          overflow: "hidden",
        }}
      >
        {title && (
          <div
            style={{
              padding: "7px 12px 5px",
              borderBottom: "1px solid #f1f5f9",
              marginBottom: 4,
            }}
          >
            <span
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#94a3b8",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
              }}
            >
              {title}
            </span>
          </div>
        )}
        <div style={{ padding: "4px 0" }}>
          {items.map((item, i) => (
            <CommandItem key={i} item={item} />
          ))}
        </div>
      </div>
    );
  };

  render() {
    const { children, disabled = false, placement = "top" } = this.props;

    if (disabled) return children;

    return (
      <Popover
        content={this.renderPanel()}
        title={null}
        trigger="hover"
        placement={placement}
        overlayStyle={{ zIndex: 2000 }}
        overlayInnerStyle={{
          padding: 0,
          borderRadius: 16,
          boxShadow: "none",
          border: "none",
        }}
      >
        {children}
      </Popover>
    );
  }
}

export default ButtonGroup